import React from 'react';
import { Link } from 'react-router-dom';

export default class AccountNotificationPreferences extends React.Component {

  render() {
    return(
      <div className='sidebar'>
        <b>Notification Settings</b>
        <div>
          <Link to='/account/notification_preferences'>Change</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/account_notification_preferences.jsx